(function () {
  if (customElements.get('ce-product-buy-buttons') !== undefined) {
    return;
  }

  class ProductBuyButtons extends HTMLParsedElement {
    constructor() {
      super();

      this.queuedAttributeChangedCallbackParams = [];

      this.selectors = {
        product: 'ce-product',
        buttonAddToCart: '[data-product-buy-buttons-button-add-to-cart]',
        buttonAddToCartText: '[data-product-buy-buttons-button-add-to-cart-text]',
        iconSpinner: '[data-product-buy-buttons-icon-spinner]',
        json: '[data-product-buy-buttons-json]',
      };

      this.elements = null;
      this.variants = null;
      this.animationLoading = null;

      this.handleProductIsLoading = this.handleProductIsLoading.bind(this);
      this.handleProductSellingPlanId = this.handleProductSellingPlanId.bind(this);
      this.handleProductVariantId = this.handleProductVariantId.bind(this);
      this.handleClickButtonAddToCart = this.handleClickButtonAddToCart.bind(this);
    }

    get isLoading() {
      return this.getAttribute('is-loading') === 'true';
    }

    set isLoading(value) {
      this.setAttribute('is-loading', value);
    }

    get isVariantAvailable() {
      return this.getAttribute('is-variant-available') === 'true';
    }

    set isVariantAvailable(value) {
      this.setAttribute('is-variant-available', value);
    }

    get sellingPlanId() {
      return this.getAttribute('selling-plan-id');
    }

    set sellingPlanId(value) {
      this.setAttribute('selling-plan-id', value);
    }

    get variantId() {
      return this.getAttribute('variant-id');
    }

    set variantId(value) {
      this.setAttribute('variant-id', value);
    }

    static get observedAttributes() {
      return ['is-loading', 'is-variant-available', 'selling-plan-id', 'variant-id'];
    }

    attributeChangedCallback(...params) {
      if (!this.parsed) {
        this.queuedAttributeChangedCallbackParams.push(params);
        return;
      }

      const [name, oldValue, newValue] = params;

      if (oldValue === newValue) {
        return;
      }

      switch (name) {
        case 'is-loading':
          if (newValue !== null) {
            if (newValue === 'true') {
              this.playAnimationLoading();

              this.elements.buttonAddToCart.setAttribute('aria-disabled', 'true');
            } else {
              this.pauseAnimationLoading();

              if (this.isVariantAvailable) {
                this.elements.buttonAddToCart.removeAttribute('aria-disabled');
              }
            }
          }

          break;
        case 'is-variant-available':
          if (newValue !== null) {
            if (newValue === 'true') {
              this.elements.buttonAddToCart.removeAttribute('aria-disabled');
              this.elements.buttonAddToCartText.innerText = Themu.t.products.buy_buttons.add_to_cart;
            } else {
              this.elements.buttonAddToCart.setAttribute('aria-disabled', 'true');
              this.elements.buttonAddToCartText.innerText = Themu.t.products.buy_buttons.unavailable;
            }
          }

          break;
        case 'selling-plan-id':
          if (newValue !== null) {
            if (newValue === '-1') {
              this.elements.buttonAddToCartText.innerText = Themu.t.products.buy_buttons.add_to_cart;
            } else {
              this.elements.buttonAddToCartText.innerText = Themu.t.products.buy_buttons.add_subscription_to_cart;
            }
          }

          break;
        case 'variant-id':
          if (newValue !== null) {
            const variant = this.variants[newValue];
            this.isVariantAvailable = variant.available;
          }

          break;
      }
    }

    parsedCallback() {
      this.elements = {
        product: this.closest(this.selectors.product),
        buttonAddToCart: this.querySelector(this.selectors.buttonAddToCart),
        buttonAddToCartText: this.querySelector(this.selectors.buttonAddToCartText),
        iconSpinner: this.querySelector(this.selectors.iconSpinner),
        json: this.querySelector(this.selectors.json),
      };

      this.variants = JSON.parse(this.elements.json.textContent);
      this.elements.json.remove();

      this.elements.product.addEventListener('ce-product:is-loading', this.handleProductIsLoading);
      this.elements.product.addEventListener('ce-product:selling-plan-id', this.handleProductSellingPlanId);
      this.elements.product.addEventListener('ce-product:variant-id', this.handleProductVariantId);

      this.elements.buttonAddToCart.addEventListener('click', this.handleClickButtonAddToCart);

      for (let params of this.queuedAttributeChangedCallbackParams) {
        this.attributeChangedCallback(...params);
      }
    }

    disconnectedCallback() {
      this.elements.product.removeEventListener('ce-product:is-loading', this.handleProductIsLoading);
      this.elements.product.removeEventListener('ce-product:selling-plan-id', this.handleProductSellingPlanId);
      this.elements.product.removeEventListener('ce-product:variant-id', this.handleProductVariantId);

      this.elements.buttonAddToCart.removeEventListener('click', this.handleClickButtonAddToCart);
    }

    handleProductIsLoading(event) {
      this.isLoading = event.detail;
    }

    handleProductSellingPlanId(event) {
      this.sellingPlanId = event.detail;
    }

    handleProductVariantId(event) {
      this.variantId = event.detail;
    }

    handleClickButtonAddToCart(event) {
      if (this.elements.buttonAddToCart.hasAttribute('aria-disabled')) {
        event.preventDefault();
        return;
      }
    }

    playAnimationLoading() {
      const keyframes = [{ transform: 'translateY(-50%) rotate(0deg)' }, { transform: 'translateY(-50%) rotate(360deg)' }];

      const options = {
        duration: Themu.prefersReducedMotion ? 2000 * 6 : 2000,
        iterations: Infinity,
        fill: 'both',
      };

      this.animationLoading = this.elements.iconSpinner.animate(keyframes, options);

      requestAnimationFrame(() => {
        this.elements.iconSpinner.style.display = 'flex';
      });
    }

    pauseAnimationLoading() {
      this.animationLoading?.cancel();

      requestAnimationFrame(() => {
        this.elements.iconSpinner.style.display = 'none';
      });
    }
  }

  customElements.define('ce-product-buy-buttons', ProductBuyButtons);
})();
